<div id="generate-course-form-wikilinks" class="text-center d-none">
    
    <h3>Seleccionar palabras clave de Wikipedia</h3>

    <div id="wikilinks-instructions">
        <p><b>Instrucciones:</b></p>
        <ol>
            <li>Añadir unidades al árbol del curso. Por ejemplo, para añadir una unidad, haga clic derecho en el árbol y luego seleccione "Insertar unidad".</li>
            <li>Luego, debe debe buscar artículos de Wikipedia de los cuales extraer información. Use el buscador de abajo para mostrar una lista de artículos que coincidan con el término de búsqueda.</li>
            <li>Una vez que se genere la lista, debe seleccionar los términos de Wikipedia y asignarlos a una unidad para pobarla de lecciones. Si desea ver el artículo, haga clic en el enlace bajo la palabra que dice "Ver artículo".</li>
        </ol>
    </div>

    <div id="wikilinks-units-tree">
        <h4>Árbol del curso</h4>
        <hr>
        <div id="wikilinks-jstree"></div>
        <hr>
        <button class="btn btn-danger mt-3" (click)="emptyUnits()">
            <i class="fa fa-trash"></i>
            <span>Vaciar</span>
        </button>
    </div>

    <div id="wikilinks-select-form">
        <fieldset>
            <legend class="fw-bold">Buscar artículos en Wikipedia</legend>
    
            <div class="row">
                <div id="wikilinks-select-form-limit">
                    <h4>Número de resultados a mostrar:</h4>
                    <input class="form-control" type="number" id="limit" min="1" value="50" 
                    [(ngModel)]="searchLimit" />
                </div>
        
                <div id="wikilinks-select-form-input">
                    <h4>Buscar en Wikipedia:</h4>
                    <input class="form-control" type="text" id="wikipedia-search-value" 
                    [(ngModel)]="searchTerm" />
                </div>

                <div id="wikilinks-select-form-order">
                    <h4>Ordenar por:</h4>
                    <select name="wikilinks-order" id="wikilinks-order" [(ngModel)]="searchOrder">
                        <option value="incoming_links_asc">Popularidad (de menos a más)</option>
                        <option value="incoming_links_desc">Popularidad (de más a menos)</option>
                        <option value="last_edit_asc">Última edición (menos a más reciente)</option>
                        <option value="last_edit_desc">Última edición (más a menos reciente)</option>
                        <option value="create_timestamp_asc">Creación (menos a más reciente)</option>
                        <option value="create_timestamp_desc">Creación (más a menos reciente)</option>
                        <!-- <option value="just_match">Just match</option> -->
                        <option value="relevance">Relevancia</option>
                        <option value="random">Al azar</option>
                        <option value="none">Sin ordenar, arbitrario</option>
                    </select>
                </div>
            </div>
            

            <div id="wikilinks-select-form-search" class="text-center" class="mt-3">
                <button id="wikipedia-search" class="btn btn-primary" (click)="wikipediaSearch()" [attr.disabled]="searching ? 'disabled' : null">
                    <i class="fa fa-search"></i>
                    <span>Buscar</span>
                </button>
                <div id="search-spinner" class="mt-3" *ngIf="searching">
                    <i class="fa fa-spinner fa-spin"></i>
                    <span>Buscando...</span>
                </div>
            </div>
        </fieldset>
    </div>
    
    <div id="wikilinks-select-results" *ngIf="wikipediaSearchResults.length > 0">
        <fieldset>
            <legend class="fw-bold">RESULTADOS</legend>
    
            <div id="wikilinks-select-results-links" *ngIf="wikipediaSearchResults.length > 0">
                <!-- <h4>Lista de términos existentes</h4> -->
                <table id="wikilinks-search-results-table">
                    <tr>
                        <th>Término</th>
                        <th>Conteo de palabras</th>
                        <th>Última edición</th>
                        <th>Unidad</th>
                        <th>Añadir al curso</th>
                    </tr>
                    <tr *ngFor="let result of wikipediaSearchResults">
                        <td>
                            <a target="_blank" href="{{ result.link }}">{{ result.word }}</a>
                        </td>
                        <td>
                            {{ result.wordcount }}
                        </td>
                        <td>
                            {{ result.lastedit }}
                        </td>
                        <td>
                            <select [(ngModel)]="result.unit">
                                <option disabled selected value="-1">Seleccione una unidad...</option>
                                <option *ngFor="let unit of units" [value]="unit.pos">
                                    {{ unit.title }}
                                </option>
                            </select>
                        </td>
                        <td>
                            <button class="btn btn-primary" title="Poblar unidad" (click)="populateUnit(result)">
                                <i class="fa fa-folder-plus"></i>
                            </button>
                            <div class="mt-3" *ngIf="result.populating">
                                <i class="fa fa-spinner fa-spin me-2"></i>
                                <span>Poblando...</span>
                            </div>
                            <div class="text-success mt-3" *ngIf="!result.populating && result.populated === true">
                                <i class="fa fa-check me-2"></i>
                                <span>¡Bien!</span>
                            </div>
                            <div class="text-danger mt-3" *ngIf="!result.populating && result.populated === false">
                                <i class="fa fa-times me-2"></i>
                                <span>¡Mal!</span>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
    
        </fieldset>
    </div>
    
    <div class="form-group text-center">
        <div id="wikilinks-spinner" *ngIf="generateLoading">
            <i class="fa fa-spinner fa-spin"></i>
            <span>Procesando, espere por favor...</span>
        </div>
        <div #error id="wikilinks-error" class="text-danger" *ngIf="generateError">
            <i class="fa fa-times"></i>
            <span>Hubo un error, no se generó el curso. Por favor, inténtelo de nuevo.</span>
        </div>
        <div #success id="wikilinks-success" class="text-success" *ngIf="generateSuccess">
            <i class="fa fa-check"></i>
            <span>Se ha generado el curso correctamente. Ahora será redireccionado, espere un momento...</span>
        </div>
    </div>

    <div class="form-group text-center">
        <button class="btn btn-primary me-3" data-direction="back" data-parent="wikilinks" data-prev="source" (click)="move($event)">
            <i class="fa fa-arrow-left"></i>
            <span>Volver</span>
        </button>
    
        <button id="wikilinks" class="btn btn-success" (click)="generateCourseWikilinks()" [attr.disabled]="generateBtnDisabled ? 'disabled': null">
            <i class="fa fa-book"></i>
            <span>Generar curso</span>
        </button>
    </div>

</div>